export const notificationsConstants = {
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',
}

export const NOTIFICATION_GROUPS = {
  borrower_created_email: { orderIndex: 0, label: 'Lender created prospect' },
  borrower_signup_email: { orderIndex: 1, label: 'New prospect signed up' },
  lender_alert_email: { orderIndex: 2, label: 'Prospect signed in' },
  lender_submitted_email: { orderIndex: 3, label: 'Application submitted' },
  document_signed_by_all: { orderIndex: 4, label: 'Document signatures completed' },
  invoice_schedule_created: { orderIndex: 5, label: 'Invoice schedule created' },
  invoice_schedule_approved: { orderIndex: 6, label: 'Invoice schedule approved' },
  invoice_schedule_purchased: { orderIndex: 7, label: 'Invoice schedule purchased' },
  funding_request_created: { orderIndex: 8, label: 'Funding request created' },
  funding_request_approved: { orderIndex: 9, label: 'Funding request approved' },
  funding_request_rejected: { orderIndex: 10, label: 'Funding request rejected' },
  funding_request_funded: { orderIndex: 11, label: 'Funding request funded' },
}
